import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import CardInfoSalon from "../../../components/admin/SalonProfile/CardInfoSalon";
import CardOnlineProfile from "../../../components/admin/SalonProfile/CardOnlineProfile";
import SalonDetails from "../../../components/admin/SalonProfile/SalonDetails";
import SalonWorkingsHour from "../../../components/admin/SalonProfile/SalonWorkingsHour";
import StaffMembers from "../../../components/admin/SalonProfile/StaffMembers";
import ActionMenuHeader from "../../../components/admin/common/ActionMenuHeader";
import useBreadcrumb from "../../../hooks/useBreadcrumb";
import {
  getLocationDetailsAdmin,
  getTeamMembersAdmin,
} from "../../../network/admin";

type Props = {};
const SalonProfile = (props: Props) => {
  let { salonName } = useParams();
  const [searchHeader, setSearchHeader] = useState();
  const [isFilter, setIsFilter] = useState({ location_ids: salonName });
  const [page, setPage] = useState(1);
  const { data, isLoading } = useQuery(["location", salonName], () =>
    getLocationDetailsAdmin(salonName)
  );
  const breadcrumb = useBreadcrumb([data?.data?.name], 1);
  const { data: StaffManagement, isLoading: isLoadingStaff } = useQuery(
    ["AdminTeamMembers", page, isFilter, searchHeader, salonName],
    () =>
      getTeamMembersAdmin({
        page,
        ...isFilter,
        location_ids: [salonName],
        search: searchHeader,
      })
  );

  return (
    <>
      {breadcrumb}
      <div className="flex flex-col justify-end gap-4">
        {isLoading ? (
          <Spin className="flex items-end justify-center" />
        ) : (
          <>
            <div className="flex items-center justify-end w-full ml-auto">
              <ActionMenuHeader LocationId={data?.data?.id} />
            </div>
            <div className="grid justify-between w-full h-full grid-cols-2 gap-4">
              <SalonDetails data={data?.data} />
              <div className="flex flex-col items-start w-full gap-4">
                <SalonWorkingsHour
                  opening_hours={data?.data?.opening_hours}
                  salonId={data?.data?.id}
                  salonName={data?.data?.name}
                />
                <div className="flex items-center w-full h-full gap-4">
                  <CardInfoSalon data={data?.data} />
                  <CardOnlineProfile data={data?.data} />
                </div>
              </div>
            </div>
            {
              <StaffMembers
                isLoading={isLoadingStaff}
                page={page}
                setPage={setPage}
                data={StaffManagement?.data}
                setIsFilter={setIsFilter}
                setSearchHeader={setSearchHeader}
                searchHeader={searchHeader}
                salonId={data?.data?.salon_id}
              />
            }
          </>
        )}
      </div>
    </>
  );
};

export default SalonProfile;
